import { Edit1 } from 'blaze-ui/icons'
import { useArticleViewLink } from 'hooks/useArticleViewLink'
import { FloatingButton } from 'blaze-ui/FloatingButton/FloatingButton'
import { ArticleView } from 'types'
import { useHistory } from 'react-router-dom'

export const EditButton = () => {
  const { to } = useArticleViewLink({ articleView: ArticleView.Editing })
  const history = useHistory()

  return (
    <FloatingButton
      icon={Edit1}
      onPress={() =>
        history.replace({
          pathname: to.pathname,
          search: to.search
        })
      }
    />
  )
}
